import { StyledBox } from "../styles";
import { ButtonContainer, FunctionArea, IntroArea } from "./styles";
import { IDPAutoIcon } from "../../../assets/dashboardIcons/idpIcons";
import { FunctionalButton } from "../../../components/functionalButton";
import React from "react";
import { useHistory } from "react-router";

type eSUBProps = { isMobile: boolean };
export const ESUB = ({ isMobile }: eSUBProps) => {
  const history = useHistory();

  return (
    <FunctionArea isMobile={isMobile}>
      {isMobile && (
        <StyledBox
          boxHeight="110px"
          borderRadius="15px"
          isMobile={isMobile}
          onClick={() => {}}
          style={{ cursor: "pointer" }}
        >
          <IntroArea>
            <IDPAutoIcon />
          </IntroArea>
          <ButtonContainer>
            <FunctionalButton
              buttonTitle="IDP Documents"
              width="80%"
              marginRight="0px"
              isReversedColor={true}
              hasBoxShadow={true}
              handleButton={() => {}}
              disabled={false}
              height={undefined}
              marginLeft={undefined}
              marginTop={undefined}
              marginBottom={undefined}
              fontSize={undefined}
              icon={undefined}
              frontIcon={undefined}
              weight={undefined}
              borderColor={undefined}
              selected={undefined}
            />
          </ButtonContainer>
        </StyledBox>
      )}
      {!isMobile && (
        <>
          <StyledBox boxHeight="216px">
            <IntroArea>
              <IDPAutoIcon />
            </IntroArea>
            <ButtonContainer>
              <FunctionalButton
                buttonTitle="View All eSUB"
                width="80%"
                marginRight="0px"
                isReversedColor={true}
                hasBoxShadow={true}
                handleButton={() => {
                  history.push("underwriter/view-e-sub");
                }}
                disabled={false}
                height={undefined}
                marginLeft={undefined}
                marginTop={undefined}
                marginBottom={undefined}
                fontSize={undefined}
                icon={undefined}
                frontIcon={undefined}
                weight={undefined}
                borderColor={undefined}
                selected={undefined}
                preserveCase
              />
            </ButtonContainer>
          </StyledBox>
        </>
      )}
    </FunctionArea>
  );
};

const ESUBTable = () => {};
